import { apiClient } from './apiClient';
import type {
  LicenseWithNavigationPropertiesDto,
  LibrarySyncResultDto,
} from '../types/library';

const BASE = '/api/app/library';

/**
 * Load the user's library. On first load for a user with bookseller sessions but
 * no licenses yet, the backend syncs synchronously and returns populated data.
 * On subsequent loads the backend returns cached DB state and fires background sync.
 */
export async function getMyLibrary(booksellerId?: string): Promise<LicenseWithNavigationPropertiesDto[]> {
  const { data } = await apiClient.get<LicenseWithNavigationPropertiesDto[]>(
    `${BASE}/my-library`,
    { params: booksellerId ? { booksellerId } : undefined },
  );
  return data;
}

/**
 * Manually trigger a sync with bookseller APIs. Exposed for a future "Sync now"
 * button; not consumed by MyLibraryPage in this iteration.
 */
export async function syncLibrary(booksellerId?: string): Promise<LibrarySyncResultDto> {
  const { data } = await apiClient.post<LibrarySyncResultDto>(
    `${BASE}/sync`,
    null,
    { params: booksellerId ? { booksellerId } : undefined },
  );
  return data;
}

/**
 * Returns the bookseller ids for which the current user has an active session.
 * Not consumed by MyLibraryPage in this iteration; reserved for future UI.
 */
export async function getMyBooksellerIds(): Promise<string[]> {
  const { data } = await apiClient.get<string[]>(`${BASE}/my-booksellers`);
  return data;
}
